if (!customElements.get('product-personalization')) {
  customElements.define(
    'product-personalization',
    class ProductPersonalization extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-personalization-toggle]');
        this.optionsFieldset = this.querySelector('[data-personalization-options]');
        this.textInput = this.querySelector('[data-personalization-text]');
        this.charCounter = this.querySelector('[data-char-current]');
        this.previewEl = this.querySelector('[data-personalization-preview]');
        this.errorEl = this.querySelector('[data-personalization-error]');
        this.fontOptions = this.querySelectorAll('[data-font-option] input[type="radio"]');
        this.colorOptions = this.querySelectorAll('[data-color-option] input[type="radio"]');
        this.placeholder = this.previewEl ? (this.previewEl.dataset.placeholder || 'Dein Text') : 'Dein Text';
        // Placeholder-Klasse initial setzen (SVG arc-text)
        if (this.previewEl) this.previewEl.classList.add('tb-personalization__arc-text--placeholder');

        if (this.toggle) this.toggle.addEventListener('change', this.onToggleChange.bind(this));
        if (this.textInput) this.textInput.addEventListener('input', this.onTextInput.bind(this));
        this.fontOptions.forEach(function(r) { r.addEventListener('change', this.updatePreview.bind(this)); }.bind(this));
        this.colorOptions.forEach(function(r) { r.addEventListener('change', this.updatePreview.bind(this)); }.bind(this));

        var form = this.closest('form');
        if (form) form.addEventListener('submit', this.onFormSubmit.bind(this), { capture: true });

        this.updateState(false);
      }

      onToggleChange() {
        var isChecked = this.toggle.checked;
        this.updateState(isChecked);
        if (isChecked && this.textInput) setTimeout(function() { this.textInput.focus(); }.bind(this), 280);
      }

      updateState(isChecked) {
        if (!this.optionsFieldset) return;
        this.optionsFieldset.disabled = !isChecked;
        this.optionsFieldset.setAttribute('aria-hidden', String(!isChecked));
        this.optionsFieldset.classList.toggle('is-open', isChecked);
      }

      onTextInput() {
        if (this.charCounter) this.charCounter.textContent = this.textInput.value.length;
        this.updatePreview();
        this.hideError();
      }

      updatePreview() {
        if (!this.previewEl) return;
        var text = this.textInput ? this.textInput.value : '';
        var fontFamily = '';
        var swatchColor = '';

        this.fontOptions.forEach(function(radio) {
          if (radio.checked) {
            var parent = radio.closest('[data-font-option]');
            var span = parent && (
              parent.querySelector('.tb-personalization__font-sample') ||
              parent.querySelector('.tb-personalization__font-preview')
            );
            if (span) fontFamily = span.style.fontFamily;
          }
        });

        this.colorOptions.forEach(function(radio) {
          if (radio.checked) {
            var parent = radio.closest('[data-color-option]');
            var swatch = parent && parent.querySelector('.tb-personalization__color-swatch');
            if (swatch) swatchColor = swatch.style.getPropertyValue('--swatch-bg').trim();
          }
        });

        // textPath-Element holen (f\u00FCr SVG arc-text)
        var textPath = this.previewEl.querySelector('textPath');
        var targetEl = textPath || this.previewEl;

        if (text && text.length > 0) {
          targetEl.textContent = text;
          this.previewEl.classList.remove('tb-personalization__arc-text--placeholder');
        } else {
          targetEl.textContent = this.placeholder || '\u00A0';
          this.previewEl.classList.add('tb-personalization__arc-text--placeholder');
        }

        if (fontFamily) this.previewEl.style.fontFamily = fontFamily;
        if (swatchColor) {
          this.previewEl.setAttribute('fill', swatchColor);
          this.previewEl.style.fill = swatchColor;
        }

        // Font-Cards zeigen immer "Aa"
        this.querySelectorAll('[data-font-card-preview]').forEach(function(span) {
          span.textContent = 'Aa';
        });
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.removeAttribute('hidden');
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.setAttribute('hidden', '');
      }

      onFormSubmit(evt) {
        if (!this.toggle || !this.toggle.checked) return;

        var text = this.textInput ? this.textInput.value.trim() : '';
        if (!text) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          this.showError('Bitte gib deinen Personalisierungstext ein.');
          if (this.textInput) this.textInput.focus();
          return;
        }
        this.hideError();

        evt.preventDefault();
        evt.stopImmediatePropagation();
        this.submitPersonalized();
      }

      submitPersonalized() {
        var self = this;
        var form = this.closest('form');
        if (!form) return;

        var submitBtn = form.querySelector('[type="submit"]');
        var spinner = submitBtn && submitBtn.querySelector('.loading__spinner');
        var errWrapper = form.querySelector('.product-form__error-message-wrapper');

        if (submitBtn) {
          submitBtn.setAttribute('aria-disabled', 'true');
          submitBtn.classList.add('loading');
          if (spinner) spinner.classList.remove('hidden');
        }
        if (errWrapper) errWrapper.setAttribute('hidden', '');

        var variantIdInput = form.querySelector('[data-tb-variant-id]');
        var variantId = variantIdInput ? parseInt(variantIdInput.value, 10) : 0;
        if (!variantId) {
          self.resetButton(submitBtn, spinner);
          return;
        }

        // Collect personalization properties from enabled fieldset
        var formData = new FormData(form);
        var properties = {};
        formData.forEach(function(value, key) {
          var match = key.match(/^properties\[(.+)\]$/);
          if (match && value) properties[match[1]] = value;
        });

        var surchargeId = parseInt(self.dataset.surchargeVariantId, 10) || 0;
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var sectionIds = (cart && typeof cart.getSectionsToRender === 'function')
          ? cart.getSectionsToRender().map(function(s) { return s.id; })
          : [];
        var cartUrl = '/cart/add.js';

        if (!surchargeId) {
          // No surcharge: add rucksack WITH sections so we can render the cart directly
          fetch(cartUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1, properties: properties }],
              sections: sectionIds,
              sections_url: window.location.pathname
            })
          })
          .then(function(r) { return r.json(); })
          .then(function(data) {
            if (data.status) {
              self.showCartError(form, errWrapper, data);
            } else {
              self.renderCart(cart, data, sectionIds, variantId);
            }
            self.resetButton(submitBtn, spinner);
          })
          .catch(function(err) {
            console.error('[Personalisierung] Fehler:', err);
            self.resetButton(submitBtn, spinner);
          });

        } else {
          // With surcharge: Step 1 add rucksack (no sections needed yet)
          fetch(cartUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1, properties: properties }]
            })
          })
          .then(function(r) { return r.json(); })
          .then(function(data) {
            if (data.status) {
              self.showCartError(form, errWrapper, data);
              self.resetButton(submitBtn, spinner);
              return;
            }

            // Step 2: add surcharge WITH sections so we render the updated cart
            fetch(cartUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({
                items: [{ id: surchargeId, quantity: 1 }],
                sections: sectionIds,
                sections_url: window.location.pathname
              })
            })
            .then(function(r) { return r.json(); })
            .then(function(surchargeData) {
              if (surchargeData.status) {
                console.warn('[Personalisierung] Aufpreis Fehler:', surchargeData.description || surchargeData.message);
                self.showError('Der Personalisierungs-Aufpreis konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
              } else {
                self.renderCart(cart, surchargeData, sectionIds, variantId);
              }
              self.resetButton(submitBtn, spinner);
            })
            .catch(function(err) {
              console.error('[Personalisierung] Aufpreis Fehler:', err);
              self.showError('Der Personalisierungs-Aufpreis konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
              self.resetButton(submitBtn, spinner);
            });
          })
          .catch(function(err) {
            console.error('[Personalisierung] Fehler:', err);
            self.resetButton(submitBtn, spinner);
          });
        }
      }

      showCartError(form, errWrapper, data) {
        var errMsg = form.querySelector('.product-form__error-message');
        if (errWrapper && errMsg) {
          errMsg.textContent = data.description || data.message;
          errWrapper.removeAttribute('hidden');
        }
      }

      renderCart(cart, data, sectionIds, variantId) {
        if (!cart) {
          window.location = (typeof routes !== 'undefined' && routes.cart_url) || '/cart';
          return;
        }
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        if (data && data.sections && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: String(variantId),
            cartData: data
          });
        }
      }

      // Fallback: fetch fresh sections data and render cart
      fetchAndRenderCart(cart, sectionIds, variantId) {
        if (!cart || !sectionIds.length) return;
        var url = '/cart/sections.js?sections=' + sectionIds.join(',');
        fetch(url)
          .then(function(r) { return r.json(); })
          .then(function(sections) {
            if (typeof cart.renderContents === 'function') {
              cart.renderContents({ sections: sections });
            }
          })
          .catch(function() {
            if (typeof cart.open === 'function') cart.open();
          });
      }

      resetButton(submitBtn, spinner) {
        if (!submitBtn) return;
        submitBtn.classList.remove('loading');
        submitBtn.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      }
    }
  );
}
